import DefaultLayout from '../../components/DefaultLayout'
import { useUserProfile } from './hooks/useUserProfile'
import { ProfileProxy } from './internal/ProfileProxy'

const Profile = () => {
    const { user } = useUserProfile()

    return (
        <DefaultLayout>
            <ProfileProxy
                profile={user?.user_metadata?.seller ? 'seller' : 'user'}
            />
        </DefaultLayout>
    )
}

export default Profile
